// Contact Section Data
// Edit this file to update contact information and form labels

export const contactData = {
  heading: "Get In Touch",
  description: "I'm always open to discussing new projects, creative ideas, or opportunities to be part of your visions.",
  email: "affanburney03@gmail.com",
  phone: "",
  location: "Atlanta, GA, USA",
  social: {
    github: "https://github.com/affan03",
    linkedin: "https://www.linkedin.com/in/affan-burney-056485194/"
  },
  form: {
    name: {
      label: "Name",
      placeholder: "Your Name"
    },
    email: {
      label: "Email",
      placeholder: "your.email@example.com"
    },
    subject: {
      label: "Subject",
      placeholder: "Project Inquiry"
    },
    message: {
      label: "Message",
      placeholder: "Your message here..."
    },
    submit: "Send Message"
  }
};

